// extracted by mini-css-extract-plugin
module.exports = {"container":"RemarksBanner_container__Tz1_1","content":"RemarksBanner_content__2aO8D","button":"RemarksBanner_button__1gMyU","row":"RemarksBanner_row__B5aY-"};